import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useBreakpoints } from '@/hooks';

function Maintenance() {
  const { isMobileDevice } = useBreakpoints();
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        width: '100%',
        height: '100vh',
        backgroundImage: 'url(/login-background.webp)',
        backgroundSize: 'cover',
        p: 2,
      }}
    >
      <Paper
        variant="elevation"
        elevation={8}
        sx={{
          width: 246 * 1.3 * 2,
          borderRadius: 4,
          p: 0.1,
        }}
      >
        <Stack direction="row" spacing={0}>
          {!isMobileDevice && (
            <Stack direction="column" width="50%">
              <img
                width={246 * 1.3}
                height={306 * 1.3}
                src="/login-background-small.png"
                style={{
                  objectFit: 'contain',
                  borderTopLeftRadius: '16px',
                  borderBottomLeftRadius: '16px',
                }}
              />
            </Stack>
          )}
          <Stack
            direction="column"
            width={isMobileDevice ? '100%' : '50%'}
            spacing={1}
            alignItems={isMobileDevice ? 'center' : 'flex-start'}
            sx={{ m: 3 }}
          >
            <img
              src="/seacube-logo-transparent-small.webp"
              width={200}
              height={52}
            />
            <Typography variant="caption">Welcome back !</Typography>
            <Stack
              direction="column"
              alignItems={isMobileDevice ? 'center' : 'flex-start'}
              spacing={2}
              sx={{ pt: 2, width: '100%' }}
            >
              <Typography
                sx={{ textAlign: isMobileDevice ? 'center' : 'left' }}
              >
                Our website is undergoing scheduled maintenance to enhance your
                experience.
              </Typography>
              <Typography>We expect to be back soon.</Typography>
              <Typography>Thank you for your patience!</Typography>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'right',
                }}
              >
                Best,
                <br />
                The Greensee Team
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
}

export { Maintenance };
